import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie9';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/base.scss';
import * as serviceWorker from './serviceWorker';

const loader = document.querySelector('.loader');

// if you want to show the loader when React loads data again
const showLoader = () => loader.classList.remove('loader--hide');

const hideLoader = () => loader.classList.add('loader--hide');

setTimeout(() => { // BORRAR SETTIMEOUT. Es para probar loader.
	ReactDOM.render((
	  <BrowserRouter>
		<App
			hideLoader={hideLoader}
			showLoader={showLoader}
		/>
	  </BrowserRouter>
	), document.getElementById('root'));
}, 1000);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
